
import { ThemeOptions } from '@mui/material/styles';

const DefaultThemeOptions: ThemeOptions = {
    typography: {
        h1: {
            fontSize: '3rem'
        },
        h2: {
            fontSize: '2.0rem',
            fontWeight: '400',
            color: '#eee'
        },
        h3: {
            fontSize: '1.25rem'
        },
        h4: {
            fontSize: '1.20rem',
            color: '#eee'
        },
        h5: {
            fontSize: '1.15rem',
            color: '#eee'
        },
        h6: {
            fontSize: '1.10rem',
            color: '#eee'
        },
        body1: {
            fontSize: '1.0rem',
            color: '#333',
            fontWeight: '400'
        },
        body2: {
            fontSize: '0.9rem',
            color: '#333'
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1250,
            xl: 1536,
        }
    },
   
}

export default DefaultThemeOptions